var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.logo_list.length > 0)?_c('section',{staticClass:"partner",style:({ 'max-width': _vm.maxWidth + 'px' })},_vm._l((_vm.logo_list),function(item,index){return _c('img',{key:index,staticClass:"logo_item",attrs:{"src":item,"alt":""}})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }